import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/customer-dashboard/loyalty/page.tsx");
